<template>
    <div>
        <div class="canvas-main-con">
            <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas>
            <canvas class="canvas-mask" width="900px" height="650px" id="canvasMask"></canvas>
        </div>
        <el-button type="primary" @click="downloadCert">下载</el-button>
    </div>
</template>

<script>
export default {
    data(){
        return{
            certificateJYZ: require("assets/images/zxpxjyzh.jpg"), //供应链运营
            person: require("assets/images/person.png"), //供应链运营
            dateMoth: ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
            dateGradeEnglish: [
                {
                    value: "物流员（仓储与配送）",
                    label: "Basic level(Warehousing&Distribution)",
                },
                {
                    value: "物流员（货物运输）",
                    label: "Basic level(Transport of goods)",
                },
                {
                    value: "助理级",
                    label: "Junior Level",
                },
                {
                    value: "初级",
                    label: "Primary Level",
                },
                {
                    value: "中级",
                    label: "Middle Level",
                },
                {
                    value: "高级",
                    label: "Senior Level",
                },
                {
                    value: "见习中级",
                    label: "Middle Level (Intern)",
                },
                // {
                //     value: "中级",
                //     label: "Middle Level.",
                // },
                // {
                //     value: "高级",
                //     label: "Senior Level.",
                // },
                {
                    value: "注册级",
                    label: "Registered  Level",
                },
            ],
            stuInfo: {
                QualifiedState: "",
                awardingUnit: "北京中物联物流采购培训中心",
                certificateNum: "GYLYY2021SZ0126",
                certificateType: "供应链运营职业技能等级证书（1+X）师资证书",
                dateofIssue: "2021年11月",
                effectiveTime: "2",
                examName: "",
                examTime: "",
                examTimeDayFZ: "18",
                examTimeDayFZa: "18",
                examTimeDayFZb: "18",
                examTimeDayFZc: "18",
                examTimeDayFZx: "18",
                examTimeDayFZy: "18",
                examTimeMonthFZ: "11",
                examTimeMonthFZx: "11",
                examTimeMonthFZy: "11",
                examTimeMonths: 11,
                examTimeMonthsa: 11,
                examTimeMonthsb: 11,
                examTimeMonthsc: 11,
                examTimeYearFZ: "2021",
                examTimeYearFZa: "2021",
                examTimeYearFZb: "2021",
                examTimeYearFZc: 2023,
                examTimeYearFZx: 2021,
                examTimeYearFZy: 2023,
                examYMEnglish: "November 2021",
                examinationGrade: "高级",
                examinationGradeEnglish: "GYLYY2021SZ0126",
                examinationGradeEnglishx: "GYLYY2021SZ0126",
                examinationGradex: "高级",
                id: "1owdaoytjzllfcbdzvjv5g",
                idCard: "612522198511170325",
                peixunName: "第二期供应链运营职业技能等级证书师资培训高级研修班",
                peixunTime: "2021/11/15~2021/11/17",
                peixunTimeDay: "02",
                peixunTimeDayx: "02",
                peixunTimeMonth: "12",
                peixunTimeMonthx: "12",
                peixunTimeYear: "2021",
                peixunTimeYearx: "2021",
                schoolName: "上海交通职业技术学院",
                sex: 1,
                siteName: "",
                studentName: "李华",
                studentNamePinyin: "Li Hua",
                studentUrl: "",
                studyTime: 40,
                studyTimeg: 32,
                studyTimegx: 32,
                studyTimex: 40,
            },
            peixunTime: "2021/11/15~2021/11/17",
            peixunTimeMonths: 11,
            peixunTimeMonthsa: 11,
        }
    },
    mounted(){
        this.getCanvasGYL();
        window.addEventListener('load', this.loadCanvas);
    },
    created(){
        
    },
    methods:{
        loadCanvas() {
            var canvas = document.getElementById('canvasMask');
            if (!canvas.getContext) {
                return;
            }
            var context = canvas.getContext('2d');
            //添加鼠标移动事件
            canvas.addEventListener('mousemove', MouseMove);
            var _this = this;
            function MouseMove(e) {
                var location = _this.windowToCanvas(canvas, e.clientX, e.clientY);
                drawLines(location.x, location.y);
            }

            //绘制辅助线
            function drawLines(x, y) {
                context.clearRect(0, 0, context.canvas.width, context.canvas.height);
                context.beginPath();
                context.moveTo(x, 0);
                context.lineTo(x, context.canvas.height);
                context.stroke();
                context.beginPath();
                context.moveTo(0, y);
                context.lineTo(context.canvas.width, y);
                context.stroke();
                context.font = '20pt Arial';
                context.fillStyle = 'green';
                var text = '(' + parseInt(x) + ',' + parseInt(y) + ')';
                context.fillText(text, 20, 50);
            }
        },
        //坐标转换
        windowToCanvas(canvas, x, y) {
            var canvasBox = canvas.getBoundingClientRect(); //获取canvas元素的边界框
            return {
                x: (x - canvasBox.left) * (canvas.width / canvasBox.width), //对canvas元素大小与绘图表面大小不一致时进行缩放
                y: (y - canvasBox.top) * (canvas.height / canvasBox.height)
            }
        },
        //方法2
        windowToCanvas2(canvas, x, y) {
            return {
                x: x + document.body.scrollLeft - document.body.clientLeft - canvas.offsetLeft,
                y: y + document.body.scrollTop - document.body.clientTop - canvas.offsetTop
            }
        },
        downloadCert() {
            var canvas = document.getElementById("canvas");
            var url = canvas.toDataURL("image/png");
            var oA = document.createElement("a");
            oA.download = this.stuInfo.studentName; // 设置下载的文件名，默认是'下载'
            oA.href = url;
            document.body.appendChild(oA);
            oA.click();
            oA.remove(); // 下载之后把创建的元素删除
        },
        getCanvasGYL() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateJYZ;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function() {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        // img.src = this.stuInfo.studentUrl + "?v=" + Math.random();
                        img.src = this.person;

                        img.onload = function() {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 180, 260, 120, 160);
                        };
                    });
                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#000";
                    ctx.fillText(`${this.stuInfo.studentName}`, 430, 295);
                    ctx.stroke();
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(0, 4)}`, 493, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(5, 7)}`, 545, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(8, 10)}`, 582, 295);
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(0, 4)}`, 635, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(5, 7)}`, 686, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(8, 10)}`, 723, 295);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 728, 520);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 635, 520);

                    
                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 693, 520);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTime}`, 475, 378);
                   
                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 208, 465);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 208, 503);

                    
                }
            });
        },
    }
}
</script>

<style lang="scss">
.canvas-main-con{
    position: relative;
    .canvas-mask{
        position: absolute;
        top: 0;
        left: 0;
    }
}
</style>